module.exports = __webpack_public_path__ + "static/PitPayLine-0f67079902773738e762eeeef5eff769.svg";